<template>
  <layout>
    <Form source="/api/calculate/" @showResults="show_results"></Form>

    <div class="card" style="padding-right:25px;">
        <TopView 
          :calculate_results="params"
          v-if="show_svg"
          @showSideView="show_side_view"
          @showCorrectionForm="show_correction_form"
          @showPdfUploadForm="show_pdf_upload_form"
        ></TopView>
    </div>
    <div class="card">
        <FrontView 
          :calculate_results="params" 
          :row="row" 
          :total_rows="total_rows"
          :corrections="corrections"
          :violation="violation"
          :show_coal="true"
          :show_lava="true"
          :show_ruler="true"
          :move_violation_to_center="true"
          v-if="show_svg"
        ></FrontView>
    </div>
    <CorrectionForm v-show="correction_form" @hideCorrectionForm="hide_correction_form" @updateCorrections="update_corrections"></CorrectionForm>
    <PdfuploadForm v-show="pdf_upload_form" @hidePdfuploadForm="hide_pdf_upload_form" :current_row="row"></PdfuploadForm>
</layout>
</template>

<script>
import Layout from "../../layouts/Base.vue";
import TopView from "./svg/TopView.vue";
import FrontView from "./front-view/FrontView.vue";

import Form from "./Form.vue";
import CorrectionForm from "./CorrectionForm.vue";
import PdfuploadForm from "./PdfuploadForm.vue";

export default {
  components: {
    Layout, Form, TopView, FrontView, CorrectionForm, PdfuploadForm
  },
  data: function () {
    return {
      results_id: this.$route.params.id,
      params: Object,
      row: 0,
      total_rows: 0,
      show_svg: false,
      first_section_in_violation: 0,
      first_section_out_violation: 0,
      correction_form: false,
      pdf_upload_form: false,
      corrections: [],
      violation: {},
    }
  },
  methods: {
    show_results(results){
      this.params = results
      this.show_svg = true
    },
    show_side_view(row){
      this.row = row
    },
    show_correction_form(){
      this.correction_form = true
    },
    show_pdf_upload_form(){
      this.pdf_upload_form = true
    },
    hide_pdf_upload_form(){
      this.pdf_upload_form = false
    },
    hide_correction_form(){
      this.correction_form = false
    },
    update_corrections(corrections, violation){
      this.corrections = corrections
      this.violation = violation
      this.correction_form = false
    },
  },
  mounted() {
  },
};
</script>




<style>
  .svg-block {
    background-image:  linear-gradient(#e9e9e9 1.2000000000000002px, transparent 1.2000000000000002px), linear-gradient(90deg, #e9e9e9 1.2000000000000002px, transparent 1.2000000000000002px), linear-gradient(#e9e9e9 0.6000000000000001px, transparent 0.6000000000000001px), linear-gradient(90deg, #e9e9e9 0.6000000000000001px, #ffffff 0.6000000000000001px);
    background-size: 30px 30px, 30px 30px, 6px 6px, 6px 6px;
    background-position: -1.2000000000000002px -1.2000000000000002px, -1.2000000000000002px -1.2000000000000002px, -0.6000000000000001px -0.6000000000000001px, -0.6000000000000001px -0.6000000000000001px;
  }
</style>
